import React, { useState } from 'react'
import toast from 'react-hot-toast'
import { isValidEmail } from '../utils/validation'

interface EmailCaptureProps {
  source: string
  className?: string
}

const EmailCapture: React.FC<EmailCaptureProps> = ({ source, className = '' }) => {
  const [email, setEmail] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [isSubmitted, setIsSubmitted] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    
    if (!email || !isValidEmail(email)) {
      toast.error('Please enter a valid email address')
      return
    }

    setIsSubmitting(true)

    try {
      // Only use Vercel serverless function - no localStorage
      const response = await fetch('/api/collect-email', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email,
          source
        })
      })

      const data = await response.json()

      if (response.ok && data.success) {
        setIsSubmitted(true)
        toast.success(data.message || 'Thank you! We\'ll notify you when Premium launches.')
        setEmail('')
      } else {
        toast.error('Unable to process your request. Please try again later.')
      }
      
    } catch (error) {
      console.error('Error submitting email:', error)
      toast.error('Service temporarily unavailable. Please try again later.')
    } finally {
      setIsSubmitting(false)
    }
  }


  if (isSubmitted) {
    return (
      <div className={`bg-green-50 border border-green-200 rounded-lg p-4 text-center ${className}`}>
        <svg className="w-12 h-12 text-green-500 mx-auto mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        <p className="text-green-800 font-semibold">You're on the list!</p>
        <p className="text-green-600 text-sm mt-1">We'll email you when Premium launches.</p>
      </div>
    )
  }

  return (
    <form onSubmit={handleSubmit} className={className}>
      <div className="flex flex-col sm:flex-row gap-3">
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Enter your email"
          className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent"
          disabled={isSubmitting}
        />
        <button
          type="submit"
          disabled={isSubmitting}
          className="px-6 py-2 bg-primary-600 text-white font-medium rounded-lg hover:bg-primary-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isSubmitting ? 'Submitting...' : 'Notify Me'}
        </button>
      </div>
      <p className="text-xs text-gray-500 mt-2">
        Be the first to know when Premium launches. No spam, ever.
      </p>
    </form>
  )
}

export default EmailCapture